'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
/*tslint:disable */
var Plaster = function Plaster(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '5 -4 59 59' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M54.6 25.9l8-8c.9-.9 1.4-2.1 1.4-3.3 0-1.3-.5-2.5-1.4-3.3L48.7-2.6c-.9-.9-2.1-1.4-3.4-1.4-1.3 0-2.5.5-3.3 1.4l-8 8L25.6-3c-1.2-1.2-3.2-1.2-4.4 0L5.9 12.3c-.6.5-.9 1.3-.9 2.2 0 .8.3 1.6.9 2.2l8.4 8.4-8 8c-1.8 1.8-1.8 4.8 0 6.7l13.9 13.9c.9.9 2.1 1.4 3.3 1.4 1.2 0 2.4-.5 3.3-1.4l8-8 8.4 8.4c.6.6 1.4.9 2.2.9.8 0 1.6-.3 2.2-.9L63 38.7c.6-.6.9-1.4.9-2.2 0-.8-.3-1.6-.9-2.2l-8.4-8.4zM8 14.5v-.2L23.3-1h.2l8.4 8.4L16.4 23 8 14.5zm16.8 37c-.7.7-1.8.7-2.4 0L8.5 37.6c-.7-.7-.7-1.8 0-2.4L44.1-.5c.4-.3.8-.5 1.2-.5.4 0 .9.2 1.2.5l13.9 13.9c.7.7.7 1.8 0 2.4L24.8 51.5zm36.1-14.9L45.6 52h-.2L37 43.5 52.5 28l8.4 8.4c.1.1.1.2 0 .2z',
        className: 'st0' }),
      _react2.default.createElement('path', { d: 'M34.8 13.1c-.2-.2-.5-.2-.7 0l-12 12c-.2.2-.2.5 0 .7l12 12c.1.1.2.1.4.1s.3 0 .4-.1l12-12c.2-.2.2-.5 0-.7l-12.1-12zm-.3 23.7L23.2 25.5l11.3-11.3 11.3 11.3-11.3 11.3z',
        className: 'st0' }),
      _react2.default.createElement('circle', { cx: '46.5', cy: '6', r: '1.5', className: 'st0' }),
      _react2.default.createElement('circle', { cx: '41.2', cy: '11.2', r: '1.5', className: 'st0' }),
      _react2.default.createElement('circle', { cx: '54', cy: '13.5', r: '1.5', className: 'st0' }),
      _react2.default.createElement('circle', { cx: '48.7', cy: '18.8', r: '1.5', className: 'st0' }),
      _react2.default.createElement('circle', { cx: '47.6', cy: '12.4', r: '1.5', className: 'st0' }),
      _react2.default.createElement('circle', { cx: '20.2', cy: '32.2', r: '1.5', className: 'st0' }),
      _react2.default.createElement('circle', { cx: '14.9', cy: '37.5', r: '1.5', className: 'st0' }),
      _react2.default.createElement('circle', { cx: '27.7', cy: '39.8', r: '1.5', className: 'st0' }),
      _react2.default.createElement('circle', { cx: '22.4', cy: '45', r: '1.5', className: 'st0' }),
      _react2.default.createElement('circle', { cx: '21.3', cy: '38.6', r: '1.5', className: 'st0' })
    )
  );
};
/*tslint:enable */
/*eslint-enable */

exports.default = Plaster;